import { facadeApi } from 'api'
import { FileItem, FileUpdateDTO } from 'types/files/files'

export interface Params {
  id: string
  data: FileUpdateDTO
}

export const updateFileApi = ({ id, data }: Params) => facadeApi.patch<FileItem>(`/file-manager/v1/files/${id}`, data)
